
export const CHECKOUT_URL = 'https://deco-emprende.impultienda.ar/checkout/deco-flores'

export const UPSELL_LINKS = {
  resina: '#deco-resina-botanica',
  bordado: '#deco-bordado-botanico',
}

export const BRAND = {
  name: 'Deco Emprende',
  product: 'Deco Flores',
  subtitle: 'Guía Completa de Prensado y Manualidades Botánicas',
  logo: 'https://cdn.magicpatterns.com/uploads/3htjHFW9hH2bn6exXMmU3L/LOGO_DECOEMPRENDE.png',
  ebookMockup:
    'https://cdn.magicpatterns.com/uploads/jx3TsnMQKdi5bY9FboFDx3/MOCK_UP_DECO_FLORES.png',
}

export const TRUST_POINTS = [
  '50+ páginas · 9 métodos de prensado',
  'Sin experiencia previa necesaria',
  'Con flores de tu propio jardín',
  '10 proyectos paso a paso',
]

export const COUNTDOWN = [
  { value: '00', label: 'Horas' },
  { value: '30', label: 'Min' },
  { value: '00', label: 'Seg' },
]

export const offerIncludes: string[] = [
  'Guía completa de 50+ páginas, ordenada de cero a pieza terminada',
  '9 métodos de prensado explicados paso a paso',
  '10 proyectos decorativos con materiales y medidas',
  '4 recursos complementarios incluidos',
  'Acceso inmediato y de por vida, desde cualquier dispositivo',
]
